import React from 'react';

interface ResizeHandleProps {
  handleAxis?: string;
}

/**
 * Custom resize handle for react-grid-layout widgets.
 *
 * Provides a visible resize affordance in the bottom-right corner
 * with hover effects to indicate interactivity.
 *
 * Features:
 * - Diagonal lines pattern (classic resize indicator)
 * - Semi-transparent by default, more visible on hover
 * - Proper cursor styling
 */
export const ResizeHandle = React.forwardRef<HTMLDivElement, ResizeHandleProps>(
  ({ handleAxis, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`react-resizable-handle react-resizable-handle-${handleAxis} group`}
        {...props}
      >
        {/* Resize grip lines */}
        <svg
          className="absolute bottom-1 right-1 w-3 h-3 text-gray-600 group-hover:text-gray-400 transition-colors"
          viewBox="0 0 12 12"
          fill="none"
        >
          {/* Diagonal lines pattern */}
          <path
            d="M10 2L2 10M10 6L6 10M10 10L10 10"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
    );
  }
);

ResizeHandle.displayName = 'ResizeHandle';
